import { render, staticRenderFns } from "./FormButton.vue?vue&type=template&id=efb73944&"
import script from "./FormButton.vue?vue&type=script&lang=js&"
export * from "./FormButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efb73944')) {
      api.createRecord('efb73944', component.options)
    } else {
      api.reload('efb73944', component.options)
    }
    module.hot.accept("./FormButton.vue?vue&type=template&id=efb73944&", function () {
      api.rerender('efb73944', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-form/components/FormButton.vue"
export default component.exports